import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form/immutable';
import {
    NEW_ITEM_FORM_NAME,
    DIGITAL_GREETINGS_FIELD,
    DIGITAL_GREETINGS_REF_ID
} from '../item/newItemForm';
import { getFilteredPaidCardsCount } from '../item/itemSelectors';
import SelectDigitalGreetings from './SelectDigitalGreetings';
import SelectedDigitalGreetings from './SelectedDigitalGreetings';
import { logError } from '../utils/errorUtils';



const DigitalGreetings = ({
    input,
    formName
}) => {
    const dispatch = useDispatch();
    const numberOfCards = useSelector(getFilteredPaidCardsCount);
    const formValues = useSelector(state => getFormValues(formName)(state));
    const isGreetingsPresent = formValues && formValues.get(DIGITAL_GREETINGS_FIELD);
    const [isGreetingSelected, setIsGreetingSelected] = useState(isGreetingsPresent);

    useEffect(() => {
        try {
            dispatch(change(formName, DIGITAL_GREETINGS_REF_ID, numberOfCards));
        } catch (error) {
            logError('Failed to initialize digital greetings count', error);
        }
    }, [dispatch, formName, numberOfCards]);

    const renderSelectGreetings = () => (
        <SelectDigitalGreetings
            formName={formName}
            setIsGreetingSelected={setIsGreetingSelected}
        />
    );

    const renderSelectedGreetings = () => (
        <SelectedDigitalGreetings
            formName={formName}
            setIsGreetingSelected={setIsGreetingSelected}
        />
    );

    return (
        <div className='digital-greetings'>
            <input {...input} type="hidden" aria-hidden="true" />
            {isGreetingSelected ? renderSelectedGreetings() : renderSelectGreetings()}
        </div>
    );
};

DigitalGreetings.propTypes = {
    input: PropTypes.shape({
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        name: PropTypes.string
    }).isRequired,
    formName: PropTypes.string,
    intl: PropTypes.object.isRequired
};

DigitalGreetings.defaultProps = {
    formName: NEW_ITEM_FORM_NAME
};

export default injectIntl(DigitalGreetings);
